import * as React from 'react';

import type {EmailableLead as EmailableLeadFragment} from 'nutshell-graphql-types';

export const EmailRelatedLeadContext = React.createContext<
    EmailableLeadFragment | null | undefined
>(null);
